













































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
  components: {}
})
export default class suppliermanage extends pagelist {
    get prox() {
    return new proxy.HistoricalBillManageServiceProxy();
  }
  input :proxy.MerchantAndChannelTypeDayBillPageInputDto = new proxy.MerchantAndChannelTypeDayBillPageInputDto();
  createrange = [];
  ctypes = [];
  merchants = [];
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '商户',
      key: 'merName'
    },
    {
      title: '商户号',
      key: 'mid'
    },
    {
      title: '产品',
      key: 'channelTypeName'
    },
    {
      title: '产品编码',
      key: 'channelTypeCode'
    },
    {
      title:'总跑',
      key:'money'
    },
    {
      title: '服务费',
      key: 'commission'
    },
    {
      title:'商户实到金额',
      key: 'payMoney'
    },
    
    {
      title: '成功笔数',
      key: 'orderNum'
    },
    
    {
      title: '结算时间',
      key: 'settlementTimeStr'
    },
    {
      title:'创建时间',
      key:'creationTime'
    }
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.prox.queryMerchantAndChannelTypeModelList(this.input).then(x => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    let creq = new proxy.ChannelTypePageInputDto();
    creq.maxResultCount = 2000;
    new proxy.ChannelTypeServiceProxy().queryModelList(creq).then((x) => {
      this.ctypes = x.items;
    });
    let mreq = new proxy.MerchantSimpleInputDto();
    new proxy.MerchantServiceProxy().queryAllList(mreq).then((x) => {
      this.merchants = x;
    });
    this.getpage();
  }
}
